import ElementsArray from './elements-array';

class GeometryElementsArray extends ElementsArray {
    _change() {
        this.geometryChange();
    }
}

export default GeometryElementsArray;